import styled from 'styled-components';
import colors from 'Styles/colors';
import { ReactComponent as ChevronDown } from 'Images/arrow-down.svg';
import { ReactComponent as CloseSVG } from 'Images/icon-close-without-background.svg';
import { ReactComponent as AssetsIcon_ } from 'Images/moveVuln.svg';

export const Wrapper = styled.div`
  width: 179px;
  align-self: center;
  margin-right: 10px;
  border-radius: 12px;
  border: solid 1px ${({ theme }) => theme.borders.vulnsCounter};
  background-color: ${({ theme }) => theme.backgrounds.vulnsCounter};
`;
Wrapper.displayName = 'Wrapper';

export const Toggle = styled.div`
  height: 31px;
  font-size: 11.5px;
  color: ${colors.dark2};
  width: 179px;
  display: flex;
  align-items: center;
  padding: 0 12px 0 9px;
  cursor: pointer;
  &:after {
    content: none;
  }
`;
Toggle.displayName = 'Toggle';

export const Menu = styled.div`
  background: ${({ theme }) => theme.backgrounds.actionDropDown};
  width: 264px !important;
  height: fit-content;
  padding-top: 8px;
  padding-bottom: 14px;
  position: absolute;
  z-index: 99;
  border-radius: 2px;
  box-shadow: 2px 2px 30px 0 ${({ theme }) => theme.shadows.actionDropDown};
  border: solid 1px ${({ theme }) => theme.borders.actionDropDown};

  a {
    text-decoration: none;
  }
`;
Menu.displayName = 'Menu';

export const Items = styled.div`
  max-height: 175px;
  overflow-y: scroll;
`;
Items.displayName = 'Items';

export const Item = styled.div`
  cursor: pointer;
  padding-left: 21px;
  padding-right: 17px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  &:hover {
    background-color: ${({ theme }) => theme.backgrounds.actionDropDownHover};
  }

  &:active {
    color: ${({ theme }) => theme.text.actionDropDownTitle};
  }
`;
Item.displayName = 'Item';

export const NoItems = styled.div`
  padding-left: 13px;
  padding-right: 13px;
  height: 43px;
  display: flex;
  align-items: center;
  font-size: 13.5px;
  font-weight: 300;
  font-stretch: normal;
  max-width: 235px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
NoItems.displayName = 'NoItems';

export const AssetSelectedIp = styled.div`
  color: ${({ theme }) => theme.text.vulnsCounter};
  max-width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11.5px;
  font-weight: 500;
  line-height: 1.0;
`;
AssetSelectedIp.displayName = 'AssetSelectedIp';

export const ArrowDown = styled(ChevronDown)`
  width: 10px;
  color: ${colors.grey5};
`;
ChevronDown.displayName = 'ChevronDown';

export const AssetOptionIp = styled.span`
  font-size: 13.5px;
  font-weight: 400;
  font-stretch: normal;
  color: ${({ theme }) => theme.text.actionDropDownItem};
  max-width: 235px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
AssetOptionIp.displayName = 'AssetOptionIp';

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0px 21px;
`;
ActionsContainer.displayName = 'ActionsContainer';

export const ViewAll = styled.span`
  font-size: 12.5px;
  font-weight: 300;
  font-stretch: normal;
  color: ${colors.blueCerulean};
  float: left;
  cursor: pointer;
  left: 21px;
`;
ViewAll.displayName = 'ViewAll';

export const CreateNew = styled.span`
  font-size: 12.5px;
  font-weight: 300;
  font-stretch: normal;
  color: ${colors.blueCerulean};
  float: right;
  cursor: pointer;
`;
CreateNew.displayName = 'CreateNew';

export const AssetVulns = styled.span`
  color: ${colors.darkBlueGrey};
  font-size: 12.5px;
  font-weight: 300;
  font-stretch: normal;
  padding-top: 1px;
`;
AssetVulns.displayName = 'AssetVulns';

export const CloseIconWrapper = styled.div`
  position: relative;
  width: 23px;
  height: 23px;
  cursor: pointer;
  border-radius: 8px;
  border: 2px solid ${({ theme }) => theme.buttons.assetSelector.border};
  background-color: ${({ theme }) => theme.buttons.assetSelector.background};
  margin-right: 6px;
`;
CloseIconWrapper.displayName = 'CloseIconWrapper';

export const CloseIcon = styled(CloseSVG)`
  position: absolute;
  left: 2.5px;
  top: 2.5px;
  margin: auto;
  width: 14px;
  height: 14px;
  cursor: pointer;
  & g {
    & path{
      fill: ${colors.grey19};
    }  
  }
`;
CloseIcon.displayName = 'CloseIcon';

export const Icons = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;
Icons.displayName = 'Icons';

export const AssetsIcon = styled(AssetsIcon_)`
  width: 16px;
  height: 12px;
  margin-right: 9px;
  & g {
    & path {
      fill: ${({ theme }) => theme.text.vulnsCounter};
    }
    & circle {
      fill: ${({ theme }) => theme.text.vulnsCounter};
      stroke: #264d6d;
    }
    & g {
      fill: ${({ theme }) => theme.text.vulnsCounter};
      stroke-width: 1.8;
    }
  }
`;
AssetsIcon.displayName = 'AssetsIcon';
